import type { MenuItem, MenuSeparator } from '@graftcode/design-system'
import { Icon } from '@graftcode/design-system'

import { DEFAULT_HELP_ITEMS, HELP_ITEM_ID } from '../help-menu.const'

export function buildPortalHelpItems(portalOnboardingLabel: string): (MenuItem | MenuSeparator)[] {
  return [
    {
      type: 'item',
      active: true,
      groups: [],
      icon: Icon.FastForwardRegular,
      label: portalOnboardingLabel,
      id: HELP_ITEM_ID.PORTAL_ONBOARDING,
      size: 'xs',
    },
    {
      id: 'help-sep-portal-tour',
      type: 'separator',
    },
    ...DEFAULT_HELP_ITEMS,
  ]
}
